<template>
  <div>
    <v-layout>
      <v-flex xs12 text-xs-center>
        <v-stepper v-model="currentStep" vertical>
          <v-stepper-step
            @click="setStepper(1)"
            step="1"
            edit-icon="person"
            complete-icon="email"
            editable
          >Details</v-stepper-step>
          <v-stepper-content step="1">
            <v-layout column>
              <v-form>
                <v-layout wrap>
                  <v-flex>
                    <v-alert icon="card_travel" color="primary" type="info" text>DISTRIBUTOR INFO</v-alert>
                  </v-flex>
                </v-layout>

                <v-flex xs12 sm8 md4>
                  <v-text-field
                    dense
                    label="Distributor name*"
                    outlined
                    v-model="distributor.name"
                  />
                  <v-textarea
                    textarea
                    dense
                    outlined
                    label="Notes"
                    auto-grow
                    rows="4"
                    v-model="distributor.notes"
                  />
                </v-flex>
              </v-form>
            </v-layout>
          </v-stepper-content>
          <v-stepper-step @click="setStepper(2)" step="2" editable>Location</v-stepper-step>
          <v-stepper-content step="2">
            <v-layout column>
              <v-form>
                <v-layout wrap>
                  <v-flex>
                    <v-alert icon="room" color="primary" type="info" text>DISTRIBUTOR LOCATION</v-alert>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 md4 pl-2 pr-2>
                    <v-text-field
                      label="Location name*"
                      outlined
                      dense
                      v-model="distributorLocation.address.name"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm8 md4 pl-2 pr-2>
                    <address-lookup
                      addressType="shippingAddresses"
                      @select_address="setSelectedAddress"
                    />
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm8 md4 pl-2 pr-2>
                    When an order is created for this location, email ________*.
                    <email-selector
                      emailSelectorLabel="Emails*"
                      :selected-emails.sync="distributorLocation.emails"
                      :email-index="0"
                      :options="[]"
                      :pricing-option="false"
                      multiple
                    />
                  </v-flex>
                </v-layout>
                <v-layout wrap mb-4>
                  <v-flex xs12 sm8 md4 pl-2 pr-2>
                    <v-textarea
                      dense
                      outlined
                      label="Notes"
                      auto-grow
                      rows="4"
                      v-model="distributorLocation.notes"
                    />
                  </v-flex>
                </v-layout>
              </v-form>
            </v-layout>
          </v-stepper-content>
          <v-stepper-step @click="setStepper(3)" step="3" editable>Confirm</v-stepper-step>
          <v-stepper-content step="3">
            <v-flex text-sm-center mt-4>
              If everything looks good, click SUBMIT to finish adding your
              distributor!
            </v-flex>
            <v-layout column mt-12>
              <v-flex text-sm-center>
                <v-btn :disabled="!validDistributor" @click="submit" color="primary">
                  Submit
                  <v-icon right>thumb_up</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-stepper-content>
        </v-stepper>
        <v-layout pb-4 pr-4 pl-4 mt-6>
          <v-btn class="mr-6" v-if="currentStep > 1" @click="previousStep" color="primary">Back</v-btn>
          <v-btn v-if="currentStep < 3" @click="nextStep" color="primary">Continue</v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import request from "@/modules/request";
import { assign } from "lodash";
import stepperMixin from "../../../mixins/stepperMixin";
import isValidEmail from "@/modules/isValidEmail";
import AddressLookup from "@/components/shared/AddressLookup";
import EmailSelector from "@/components/shared/EmailSelector";

export default {
  name: "AddDistributor",
  mixins: [stepperMixin],
  data() {
    return {
      distributorEmailErrors: [],
      distributorLocation: {
        address: {
          formatted_address: null,
          name: null,
          address1: null,
          address2: null,
          city: null,
          state: null,
          zip: null,
        },
        emails: [],
        notes: null,
      },
      distributor: {
        name: null,
        notes: null,
      },
    };
  },
  components: {
    AddressLookup,
    EmailSelector,
  },
  computed: {
    validDistributor() {
      const { distributor } = this;
      return (
        distributor.name &&
        this.validLocations &&
        !this.distributorEmailErrors.length
      );
    },
    validLocations() {
      const { address, emails } = this.distributorLocation;
      return address.name && address.formatted_address && emails.length;
    },
  },
  methods: {
    setSelectedAddress(address) {
      const { formatted_address, address1, city, state, zip } = address;
      Object.assign(this.distributorLocation.address, {
        formatted_address,
        address1,
        city,
        state,
        zip,
      });
    },
    async checkUniqueDistributorEmail() {
      const results = await request.callInternal({
        method: "post",
        route: "/api/checkunique",
        data: {
          model: "distributor",
          field: "email",
          value: this.distributor.email,
        },
      });
      return (this.distributorEmailErrors = results.data
        ? []
        : ["This email is already taken"]);
    },
    clearData() {
      this.currentStep = 1;
      assign(this.distributor, {
        name: null,
        email: null,
        phone: null,
        notes: null,
      });

      assign(this.distributorLocation, {
        address: {
          name: null,
          address1: null,
          address2: null,
          city: null,
          state: null,
          zip: null,
        },
        notes: null,
      });
    },
    async submit() {
      const { distributor, distributorLocation } = this;
      const distrResults = await request
        .callInternal({
          method: "post",
          route: "/api/admin/distributor",
          data: distributor,
        })
        .catch((error) => {
          return this.$swal({
            title: "Error",
            text: `Sorry, something went wrong with adding ${distributor.name}.`,
            icon: "error",
          });
        });
      distributorLocation.distributor = distrResults.data._id;
      await request
        .callInternal({
          method: "post",
          route: "/api/admin/distributorlocation",
          data: distributorLocation,
        })
        .then(() => {
          this.$swal({
            title: "Congratulations!",
            text: `${distributor.name} has been added.`,
            icon: "success",
          });
        })
        .catch((error) => {
          return this.$swal({
            title: "Error",
            text: `Sorry, something went wrong with adding ${distributor.name}.`,
            icon: "error",
          });
        });

      this.clearData();
    },
  },
};
</script>
